// Guarda qual estabelecimento está selecionado no painel.
//
// O seletor fica no dashboard, mas a escolha precisa valer em Banners,
// Notificações e demais telas. Como o estado do dashboard morre na navegação,
// persistimos aqui — mesmo mecanismo já usado para o token.

const STORAGE_KEY = "selectedEstablishmentId";

/** ID do estabelecimento em uso, ou string vazia se nenhum foi escolhido. */
export const getSelectedEstablishment = (): string => {
  try {
    return localStorage.getItem(STORAGE_KEY) || "";
  } catch {
    return "";
  }
};

/** Grava a escolha feita no seletor do painel. */
export const setSelectedEstablishment = (id: string): void => {
  try {
    if (id) {
      localStorage.setItem(STORAGE_KEY, id);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* modo privado do navegador pode bloquear — segue sem persistir */
  }
};

/** Limpa a seleção. Chamar no logout, para não vazar entre contas. */
export const clearSelectedEstablishment = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignora */
  }
};

/**
 * Monta a query string do estabelecimento para anexar às chamadas.
 * Retorna "" quando não há seleção, para a URL não ficar malformada.
 */
export const establishmentQuery = (prefix: "?" | "&" = "?"): string => {
  const id = getSelectedEstablishment();
  return id ? `${prefix}estabilishment=${encodeURIComponent(id)}` : "";
};